import { useDispatch, useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';

import constants from '../../Config/constants';
import { getWebActiveOrdersLimit } from '../../Helper/RemoteConfig';
import routeList from '../../Routes/list';
import { setOrderBannerMinimized } from '../../RTK/utility';
import useOrderController from '../../Screens/Orders/index.controller';

function useOngoingOrderBanner() {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const loadActiveOrders = useSelector(
    (state) => state.utility.loadAllStoresAndActiveOrders,
  );
  const isMinimized = useSelector(
    (state) => state.utility.isOrderBannerMinimized,
  );
  const { data } = useOrderController(loadActiveOrders);

  const webActiveOrdersLimit = getWebActiveOrdersLimit();

  const _goToOrders = (highlightId) => {
    const params = constants.isWeb ? {} : { activeTab: 1 };
    const route = constants.isWeb ? routeList.BASKET_TAB : routeList.BASKET;
    if (highlightId) {
      params.highlightOrderId = highlightId;
    }
    navigation.navigate(route, params);
  };

  const _toggleBanner = () => {
    setTimeout(() => {
      dispatch(setOrderBannerMinimized(!isMinimized));
    }, 0);
  };

  return {
    hasSeeMore: constants.isWeb
      ? data.length > webActiveOrdersLimit
      : data?.length > 1,
    isMinimized,
    order: data?.[0], // use on mobile
    orders: data?.slice?.(0, webActiveOrdersLimit), // used on web
    goToOrders: _goToOrders,
    toggleBanner: _toggleBanner,
  };
}

export default useOngoingOrderBanner;
